module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-E-shadow.d11f837f.png";